export const pageIdSym = Symbol('pageId')
export const contextIdSymbol = Symbol('contextId')
export const PageAssetsLoaderSymbol = Symbol('PageAssetsLoaderSymbol')
